import ParkPointLoader from '../classes/loaders/ParkPointLoader';

const parkPointLoader = new ParkPointLoader();

export default class DisjointParkPointStore {
  public processing: boolean = false;
  public total: number = 0;
  public count: number = 0;
  public rest: number = 0;

  public disjointPoints() {
    parkPointLoader.disjointPoints({
      onStart: total => {
        this.processing = true;
        this.total = total;
      },
      onProcess: count => {
        this.count = count;
      },
      onFinish: rest => {
        this.processing = false;
        this.count = 0;
        this.rest = rest;
      },
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/stores/DisjointParkPointStore.ts